export default __webpack_public_path__ + "static/media/office1.60191d03.png";